import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
	setForegroundColor,
	setChartPalette,
	setAccentColor,
	getChartColorPalette,
	getForegroundColor,
	getAccentColor,
	setBackgroundColor,
	getBackgroundColor,
} from "../../app/contrastSlice";

// Watch for when the body style and classes change then update contrast state.
export function ContrastObserver() {
	const dispatch = useDispatch();

	useEffect(() => {
		const update = () => {
			dispatch(setBackgroundColor(getBackgroundColor()));
			dispatch(setForegroundColor(getForegroundColor()));
			dispatch(setChartPalette(getChartColorPalette()));
			dispatch(setAccentColor(getAccentColor()));
		};
		update();
		const observer = new MutationObserver(update);
		observer.observe(document.body, {
			attributes: true,
			attributeFilter: ["style", "class"],
		});

		return () => observer.disconnect();
	}, [dispatch]);

	return null;
}
